import { ChevronRightIcon, HomeIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface PageHeaderProps {
  /** Usually the page's name. Widened from `string` to a node for U-03, so a
   *  header can put a mark beside the name (the broker insurer page draws the
   *  company's logo there) without every page needing its own header. A plain
   *  string is still a node, so no existing caller changes. */
  title: React.ReactNode;
  subtitle?: string;
  breadcrumbs?: BreadcrumbItem[];
  actions?: React.ReactNode;
}

export function PageHeader({ title, subtitle, breadcrumbs, actions }: PageHeaderProps) {
  return (
    <div className="mb-6">
      {/* Breadcrumbs */}
      {breadcrumbs && breadcrumbs.length > 0 && (
        <nav className="flex items-center text-sm text-gray-500 dark:text-gray-400 mb-2">
          <Link to="/dashboard" className="hover:text-gray-700 dark:hover:text-white">
            <HomeIcon className="w-4 h-4" />
          </Link>
          {breadcrumbs.map((item, index) => (
            <span key={index} className="flex items-center">
              <ChevronRightIcon className="w-4 h-4 mx-2" />
              {item.href ? (
                <Link to={item.href} className="hover:text-gray-700 dark:hover:text-white">
                  {item.label}
                </Link>
              ) : (
                <span className="text-gray-900 dark:text-white font-medium">{item.label}</span>
              )}
            </span>
          ))}
        </nav>
      )}

      {/* Title and Actions */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">{title}</h1>
          {subtitle && <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">{subtitle}</p>}
        </div>
        {actions && <div className="flex items-center gap-3">{actions}</div>}
      </div>
    </div>
  );
}
